import { WalkingIcon, TransitIcon, CarIcon } from '@/assets/icons'
import React from 'react'
import {
	TravelSegmentContainer,
	TravelDotColumn,
	TravelDotLine,
	TravelDotLineTop,
	IconWrapper,
	SegmentContent,
	InfoContainer,
	Bullet,
	DirectionsText,
} from './TravelSegment.styles'
import { TravelSegmentProps } from './types'

const TravelSegment: React.FC<TravelSegmentProps> = ({ segment, isHidden = false }) => {
	const formatDuration = (seconds: number | null): string => {
		if (seconds === null) return 'N/A'
		const minutes = Math.round(seconds / 60)
		return `${minutes} Mins`
	}

	const formatDistance = (meters: number | null): string => {
		if (meters === null) return 'N/A'
		const miles = meters / 1609.344
		return `${miles.toFixed(1)} Mi`
	}

	const hasData = (r: typeof segment.transitRoute) =>
		r != null && (r.durationSeconds !== null || r.distanceMeters !== null)

	const route = hasData(segment.transitRoute)
		? segment.transitRoute
		: hasData(segment.walkingRoute)
			? segment.walkingRoute
			: (segment.transitRoute || segment.walkingRoute)

	if (!route) return null

	const { durationSeconds, distanceMeters, transportMode, originPlaceId, destinationPlaceId } = route

	const handleClick = () => {
		const travelMode = transportMode.toLowerCase()
		const webURLString = `https://www.google.com/maps/dir/?api=1&origin=${originPlaceId}&origin_place_id=${originPlaceId}&destination=${destinationPlaceId}&destination_place_id=${destinationPlaceId}&travelmode=${travelMode}`
		window.open(webURLString, '_blank', 'noopener,noreferrer')
	}

	const getIcon = () => {
		switch (transportMode) {
			case 'TRANSIT':
				return <TransitIcon />
			case 'WALKING':
				return <WalkingIcon />
			default:
				return <CarIcon />
		}
	}

	return (
		<TravelSegmentContainer $isHidden={isHidden}>
			<TravelDotColumn>
				<TravelDotLineTop />
				<IconWrapper>{getIcon()}</IconWrapper>
				<TravelDotLine />
			</TravelDotColumn>
			<SegmentContent onClick={handleClick}>
				<InfoContainer>
					{durationSeconds === null && distanceMeters === null ? (
						<span>ETA N/A</span>
					) : (
						<>
							<span>{formatDuration(durationSeconds)}</span>
							<Bullet>·</Bullet>
							<span>{formatDistance(distanceMeters)}</span>
						</>
					)}
				</InfoContainer>
				<DirectionsText>Directions →</DirectionsText>
			</SegmentContent>
		</TravelSegmentContainer>
	)
}

export default TravelSegment
